"use strict";
/*
 * Created on 12 20 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SelloutIdentificationFilter_1 = require("../model/sellout-identification/SelloutIdentificationFilter");

var SelloutType_1 = require("../model/SelloutType");

var SelloutIdentificationFilterConverter_1 = require("./SelloutIdentificationFilterConverter");
/**
 * @author Jaroslav Sevcik
 */


var SelloutIdentificationFilterConverterImpl =
/*#__PURE__*/
function (_SelloutIdentificatio) {
  _inherits(SelloutIdentificationFilterConverterImpl, _SelloutIdentificatio);

  function SelloutIdentificationFilterConverterImpl() {
    _classCallCheck(this, SelloutIdentificationFilterConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutIdentificationFilterConverterImpl).call(this));
  }
  /**
   * @inheritDoc
   */


  _createClass(SelloutIdentificationFilterConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new SelloutIdentificationFilter_1.SelloutIdentificationFilter(conversions.asObjectList(source, 'selloutTypes', function (type) {
        return conversions.asEnum(type, SelloutType_1.SelloutType);
      }), conversions.asObjectList(source, 'categoryIds', function (id) {
        return id;
      }), conversions.toClassReferenceId(source.priceZoneId), conversions.asObjectList(source, 'siteIds', function (id) {
        return conversions.toClassReferenceId(id);
      }), conversions.asObjectList(source, 'productExternalIds', function (id) {
        return id;
      }), source.inRelease);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return {
        selloutTypes: conversions.asObjectArray(source, 'selloutTypes', function (type) {
          return type;
        }),
        categoryIds: conversions.asObjectArray(source, 'categoryIds', function (id) {
          return id;
        }),
        priceZoneId: conversions.toDocumentReferenceId(source.priceZoneId),
        siteIds: conversions.asObjectArray(source, 'siteIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        }),
        productExternalIds: conversions.asObjectArray(source, 'productExternalIds', function (id) {
          return id;
        }),
        inRelease: source.inRelease
      };
    }
  }]);

  return SelloutIdentificationFilterConverterImpl;
}(SelloutIdentificationFilterConverter_1.SelloutIdentificationFilterConverter);

exports.SelloutIdentificationFilterConverterImpl = SelloutIdentificationFilterConverterImpl;